export const NOTIFICATION_TEMPLATE_LIST_PATH =
  "/settings-menu/notification-templates";
